module.exports = __webpack_public_path__ + "img/yd1@2x.02f5a44a.png";